import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  isLoading: boolean;
  loadingMessage: string | null;
}

const initialState: UIState = {
  isLoading: false,
  loadingMessage: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setGlobalLoading: (state, action: PayloadAction<{ isLoading: boolean; message?: string }>) => {
      state.isLoading = action.payload.isLoading;
      state.loadingMessage = action.payload.message || null;
    },
    clearGlobalLoading: (state) => {
      state.isLoading = false;
      state.loadingMessage = null;
    },
  },
});

export const { setGlobalLoading, clearGlobalLoading } = uiSlice.actions;
export default uiSlice.reducer;
